<template>
  <HeroIcon
    v-if="resolvedIcon.library === 'hero' && resolvedIcon.name"
    :name="resolvedIcon.name"
    :iconStyle="resolvedIcon.style || 'outline'"
    :color="color"
    :size="size"
    aria-hidden="true"
  />
  <LucideIcon
    v-else-if="resolvedIcon.library === 'lucide' && resolvedIcon.name"
    :name="resolvedIcon.name"
    :size="size"
    :stroke-width="resolvedIcon.strokeWidth || 1.5"
    :color="color"
    aria-hidden="true"
  />
  <img
    v-else-if="resolvedIcon.library === 'image' && resolvedIcon.src"
    :src="resolvedIcon.src"
    :style="imageStyle"
    class="app-icon-image"
    alt=""
    aria-hidden="true"
    loading="lazy"
    draggable="false"
  />
</template>

<script setup>
import { computed } from 'vue'
import HeroIcon from './HeroIcon.vue'
import LucideIcon from './LucideIcon.vue'
import { getIcon } from '../services/iconRegistry.ts'

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  size: {
    type: Number,
    default: null,
  },
  color: {
    type: String,
    default: null,
  },
})

const resolvedIcon = computed(() => getIcon(props.name))

const imageStyle = computed(() => {
  if (props.size === null || props.size === undefined) return null
  return { width: `${props.size}px`, height: `${props.size}px` }
})
</script>

<style scoped>
.app-icon-image {
  object-fit: contain;
  flex-shrink: 0;
}
</style>
